import React, { lazy, useEffect, useState } from "react";

import { Layout } from "antd";
import GlobalStoreContext from "../../context/GlobalStoreContext";
import Helper from "../../Helper";
import Permission from "../../Permission";
import TeamInfo from "../../teamInfo";
import AcceptInviteModal from "../Team/acceptInviteModal";
import TeamAvatar from "../Team/teamAvatar";
import CommandCenterButton from "../UI/CommandCenterButton";
import SidebarControlButton from "../UI/SidebarButton";
import AddTeamToProjectModal from "./AddTeamToProjectModal/addTeamToProjectModal";
import InstallPLOTModal from "./installPLOTModal";
import ProjectBanner from "./ProjectBanner";
import RequestToJoinProject from "./RequestToJoinProject";

const ProjectPortal = lazy(() => import("./ProjectPortal/projectPortal"));

const ProjectSettings = lazy(() => import("./ProjectSettings/projectSettings"));
const LeadTimesPage = lazy(() => import("../../views/leadTimesPage"));
const NotificationsList = lazy(() => import("../Chat/NotificationsList"));
const ProjectCalendar = lazy(() => import("../Calendar/calendar"));
const ProjectLogistics = lazy(() => import("./ProjectLogistics/projectLogistics"));
const ProjectMembers = lazy(() => import("./projectMembers"));
const PromptJobsiteActiveModal = lazy(() => import("./promptJobsiteActive"));
const PromptForNotificationPreferencesModal = lazy(() => import("../Profile/PromptForNotificationPreferencesModal"));

const { Content } = Layout;

interface ProjectProps {
    eventId?: string;
    page?: string;
}

const Project: React.FC<ProjectProps> = (props) => {
    const context = React.useContext(GlobalStoreContext);

    const [activePromptVisible, setActivePromptVisible] = useState<boolean>(false);
    const [installPLOTModalVisible, setInstallPLOTModalVisible] = useState<boolean>(false);
    const [mtTeam, setMtTeam] = useState<any>(null);
    const [showJoinTeam, setShowJoinTeam] = useState<boolean>(false);
    const [projectTabs, setProjectTabs] = useState<any[]>([]);
    const [tabsLoaded, setTabsLoaded] = useState<boolean>(false);

    useEffect(() => {
        getInvitedTeam();
    }, []);

    useEffect(() => {
        if (context.currentProjectInfo) {
            buildProjectTabs(context.currentProjectInfo);
        }
    }, [context.currentProjectInfo.use_lead_times]);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("event")) {
            updateTabAndCookie("deliveries");
        } else if (props.page) {
            switch (props.page.toLowerCase()) {
                case "portal":
                    updateTabAndCookie("portal");
                    break;
                case "logistics":
                    updateTabAndCookie("logistics");
                    break;
                case "events":
                    updateTabAndCookie("deliveries");
                    break;
                case "lead_times":
                    updateTabAndCookie("procurement");
                    break;
                case "directory":
                    updateTabAndCookie("directory");
                    break;
            }
        } else if (Helper.getCookie("last_project_tab")) {
            updateTabAndCookie(Helper.getCookie("last_project_tab"));
        } else {
            updateTabAndCookie("portal");
        }
    }, [projectTabs]);

    const oldTabLogic = (val: number) => {
        switch (val) {
            case 1:
                updateTabAndCookie("logistics");
                break;
            case 2:
                updateTabAndCookie("deliveries");
                break;
            case 3:
                updateTabAndCookie("procurement");
                break;
            case 4:
                updateTabAndCookie("directory");
                break;
            default:
                updateTabAndCookie("portal");
                break;
        }
    };

    const getInvitedTeam = () => {
        if (Helper.getCookie("invited_team") !== "" && Helper.getCookie("invited_team_id") !== "") {
            const team = Helper.getCookie("invited_team");
            const team_id = Helper.getCookie("invited_team_id");
            const teamInfo = { id: parseInt(team_id), team_name: team };

            setMtTeam(teamInfo);
            setShowJoinTeam(true);
        } else {
            if (context.currentViewedTeamInfo) {
                const t = new TeamInfo(context.currentViewedTeamInfo);
                const teamInfo = { id: t.id, team_name: t.team_name };

                setMtTeam(teamInfo);
                setShowJoinTeam(true);
            }
        }
    };

    const updateTabAndCookie = (val) => {
        if (typeof val === "number") {
            oldTabLogic(val);
        }
        context.setActiveSidebarKey(val);
        Helper.setCookie("last_project_tab", val, 365);
    };

    const buildProjectTabs = async (projectInfo: any = context.currentProjectInfo) => {
        const tempProjectTabs = [
            {
                key: "portal",
                component: <ProjectPortal />,
            },
            {
                key: "logistics",
                component: <ProjectLogistics />,
            },
            {
                key: "directory",
                component: <ProjectMembers />,
            },
            { key: "settings", component: <ProjectSettings /> },
        ];
        if (projectInfo.use_lead_times) {
            tempProjectTabs.splice(2, 0, {
                key: "procurement",
                component: (
                    // <Suspense
                    //     fallback={<Skeleton variant="rectangular" width={"100%"} height={"100%"} animation="wave" />}
                    // >
                    <LeadTimesPage />
                    // </Suspense>
                ),
            });
        }
        if (projectInfo.use_deliveries) {
            tempProjectTabs.splice(2, 0, {
                key: "deliveries",
                component: (
                    // <Suspense
                    //     fallback={<Skeleton variant="rectangular" width={"100%"} height={"100%"} animation="wave" />}
                    // >
                    <ProjectCalendar />
                    // </Suspense>
                ),
            });
        }
        return setProjectTabs(tempProjectTabs);
    };

    useEffect(() => {
        if (projectTabs.length > 0) {
            setTabsLoaded(true);
        }
    }, [projectTabs]);

    return (
        <>
            {/*<Suspense>*/}
            <Content className="wrapper_inner" style={{ margin: "0", height: "100%", borderRadius: "0px" }}>
                <ProjectBanner projectInfo={context.currentProjectInfo} />
                <AddTeamToProjectModal
                    visible={context.addTeamToProjectModal != null}
                    onClose={() => context.setAddTeamToProjectModal(null)}
                    onSelect={() => {}}
                    vendorMode={context.addTeamToProjectModal === "vendor"}
                />
                <InstallPLOTModal
                    visible={installPLOTModalVisible}
                    hideModal={() => setInstallPLOTModalVisible(false)}
                />
                {context.gottenUserInfo &&
                    showJoinTeam &&
                    context.userHasPermission(Permission.is_invited, mtTeam?.id, null) && (
                        <AcceptInviteModal
                            team={mtTeam}
                            teamId={mtTeam?.id}
                            teamName={mtTeam?.team_name}
                        ></AcceptInviteModal>
                    )}
                {!context.isMobile ? (
                    <div
                        id="project-header"
                        className={Helper.classNames(
                            "flex flex-row justify-start items-center gap-4 px-4",
                            context.isMobile && "mt-10"
                        )}
                    >
                        <div className="flex flex-row items-center">
                            <SidebarControlButton />
                        </div>
                        <div className="truncate page-title">
                            <h1 className="flex flex-row items-center">
                                {context.currentViewedTeamInfo && (
                                    <div
                                        onClick={() => {
                                            window.location.href = Helper.baseUrlAltSubdomain(
                                                context.currentViewedTeamInfo?.subdomain || ""
                                            );
                                        }}
                                    >
                                        <TeamAvatar variant="rounded" team={context.currentViewedTeamInfo} size={48} />
                                    </div>
                                )}
                                <span className="ml-4">{context.currentProjectInfo.project_name}</span>
                            </h1>
                        </div>

                        <div className="flex flex-row items-center gap-4 justify-between">
                            {/* <Suspense
                                fallback={
                                    <Skeleton variant="rectangular" width={"100%"} height={"100%"} animation="wave" />
                                }
                            > */}
                            <PromptJobsiteActiveModal
                                visible={activePromptVisible}
                                closeModal={() => {
                                    setActivePromptVisible(false);
                                }}
                            />
                            {/* </Suspense> */}
                        </div>

                        {context.userHasPermission(
                            Permission.is_member,
                            context.currentTeam?.id,
                            context.currentProjectInfo.id
                        ) && <CommandCenterButton project={context.currentProjectInfo} />}
                    </div>
                ) : (
                    <div className="menu-title">
                        <div className="page-title flex flex-row items-center justify-between gap-4">
                            <SidebarControlButton />

                            <h1 className="flex flex-row items-center w-full">
                                {context.currentViewedTeamInfo && (
                                    <TeamAvatar team={context.currentViewedTeamInfo} size={48} />
                                )}

                                <span className="ml-2">{context.currentProjectInfo.project_name}</span>
                            </h1>
                            {!context.userHasPermission(
                                Permission.is_member,
                                context.currentTeam?.id,
                                context.currentProjectInfo.id
                            ) && <RequestToJoinProject />}
                        </div>
                    </div>
                )}

                {tabsLoaded && (
                    <>
                        {projectTabs.find((tab) => tab.key === context.activeSidebarKey)
                            ? projectTabs.find((tab) => tab.key === context.activeSidebarKey).component
                            : projectTabs[0].component}
                    </>
                )}
                {/* Notifications are for  */}
                <NotificationsList />

                {/* {projectTabs.map((tab, index) => (
                        <TabPanel value={activeIndex} index={index} key={index} className="tab-panel">
                            {tab.component}
                        </TabPanel>
                    ))} */}

                {context.userInfo && <PromptForNotificationPreferencesModal userInfo={context.userInfo} />}
            </Content>
            {/*</Suspense>*/}
        </>
    );
};

export default Project;
